import { render, staticRenderFns } from "./EditBbsData.vue?vue&type=template&id=6ebf9ab5&scoped=true&"
import script from "./EditBbsData.vue?vue&type=script&lang=js&"
export * from "./EditBbsData.vue?vue&type=script&lang=js&"
import style0 from "./EditBbsData.vue?vue&type=style&index=0&id=6ebf9ab5&prod&lang=less&scoped=true&"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebf9ab5",
  null
  
)

export default component.exports